// Custom Imports
// =========================================================
import { FormatKey } from 'src/app/utils/global_functions'
import { GenerateDefaultColDefs } from '../02_global-settings/global-cell-formatter'
import { CellClassRules } from '../02_global-settings/cell-class-rules'
import moment from 'moment'

export interface StoreIndex_GridDataParams {
  mainColDefs: any[]
  detailColDefs?: any[]
}

export async function StoreIndex_GenerateGridData (params: StoreIndex_GridDataParams) {
  const { mainColDefs, detailColDefs } = params

  const getResults = async () => {
    console.log('detailColDefs', detailColDefs)
    const mainCols = await GenerateCols(mainColDefs, 'main')
    const detailCols = await GenerateCols(detailColDefs, 'detail')
    console.log('detailCols: ', detailCols)

    const results = await Promise.all([mainCols, detailCols])
    const m = results.indexOf(mainCols)

    const data = {
      mainColDefs: results[0],
      detailColDefs: results[1]
    }
    return data
  }
  return await getResults()
}

export const StoreIndex_customCellFormatting = (col, gridToRender) => {
  const getParams = () => {
    // Main Grid Settings
    if (gridToRender === 'main') {
      // console.log('col.colId', col.colId)
      switch (col.colId) {
        case 'output':
          return {
            cellRendererParams: params => {
              const { statuses, is_editable, job_name } = params.data
              const allStatusesSame = statuses.every(status => status === statuses[0])
              const targetStatuses = ['RUNNING', 'FAILED', 'PENDING']
              const isTargetStatus = allStatusesSame && targetStatuses.includes(statuses[0])
              return {
                disabled: isTargetStatus,
                disabledKeys: ['statuses'],
                toolTipMessage: `${'View/Edit'} Job Output: ${job_name}`,
                onClick: params => params.context.onOpenOutputModal(params)
              }
            }
          }
        case 'edit':
          return {
            cellRendererParams: params => {
              const { statuses, is_editable, job_name } = params.data
              return {
                disabled: statuses.includes('RUNNING'),
                disabledKeys: ['statuses'],
                toolTipMessage: `${
                                    is_editable &&
                                    (statuses.includes('GENERATED') ||
                                        statuses.includes('FAILED') ||
                                        statuses.includes('PENDING'))
                                        ? 'View/Edit'
                                        : 'View'
                                } Job: ${job_name}`,
                onClick: params => params.context.onOpenEditJobModal(params)
              }
            }
          }
      }
    }
  }
  const updatedCol = {
    ...col,
    ...getParams(),
    cellClassRules: {
      ...CellClassRules,
      'cell-warning': params => {
        const val = params.value ? params.value.toString().toLowerCase() : params.value
        // console.log("highlight cell: ", params)
        return col.colId === 'status' && val === 'failed'
      },
      'cell-alert': params => {
        const val = params.value ? params.value.toString().toLowerCase() : params.value
        return col.colId === 'status' && val === 'completed with errors'
      }
    }
  }
  return updatedCol
}

export const GenerateCols = async (data: any[], gridToRender: string) => {
  const mappedCols = {}

  Object.entries(data).map(([colKey, colVal]) => {
    const colId = colVal.refData?.custom_field || FormatKey(colKey)

    const obj = {
      ...GenerateDefaultColDefs(colKey, { colId, ...colVal })
    }
    Object.assign(mappedCols, {
      [obj.colId]: StoreIndex_customCellFormatting(obj, gridToRender)
    })
  })
  return Object.values(mappedCols)
}
